import StorageHelper from '../../../../helper.js';

const scope = 'SB/dashboard/shares';

const defaultState = {
    filterCampaignId: 0,
    filterNetwork: 'all'
};

const mod = {
    namespaced: true,
    state: {
        filterCampaignId: 0,
        filterNetwork: 'all'
    },
    actions: {
        filterCampaignId({ commit }, campaignId) {
            StorageHelper.setLocalStorageVar(commit, campaignId || null, 'filterCampaignId', scope);
        },
        filterNetwork({ commit }, network) {
            StorageHelper.setLocalStorageVar(commit, network || null, 'filterNetwork', scope);
        },
        reset({ commit }) {
            StorageHelper.resetState(commit, defaultState, scope);
        }
    },
    getters: {
        filterCampaignId (state) {
            return state.filterCampaignId;
        },
        filterNetwork (state) {
            return state.filterNetwork;
        }
    },
    mutations: {
        filterCampaignId: (state, campaignId) => {
            state.filterCampaignId = campaignId;
        },
        filterNetwork: (state, network) => {
            state.filterNetwork = network;
        }
    }
};

export default mod;
